import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Get the current list of supported Models
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetModels = packet => {
  return {
    type: 'REQUEST_GET_MODELS',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetModelsSuccess = data => ({
  type: 'RECEIVE_GET_MODELS_SUCCESS',
  data
})

export const receiveGetModelsFail = data => ({
  type: 'RECEIVE_GET_MODELS_FAIL',
  data
})

export const tryToGetModels = packet => (dispatch, getState) => {

  dispatch(requestGetModels(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/intel/models', {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetModelsSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetModelsFail({errors:e, lastSubmit: packet}));
    })
}
